import React, { useMemo, useState } from 'react';
import { GenericListPage } from '../../components/generic';
import { useUsers, User } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';
import { useTheme } from '../../contexts/ThemeContext';
import { cn } from '../../lib/utils';
import { InviteUserModal } from './InviteUserModal';

const List: React.FC = () => {
  const { colors } = useTheme();
  const { mutate } = useUsers();
  const [inviteOpen, setInviteOpen] = useState(false);
  const config = useMemo(
    () => ({
      ...moduleConfig,
      getColumns,
      getToolbarIcon,
      getTableActions,
      toolbar: {
        ...moduleConfig.toolbar,
        actions: [
          ...moduleConfig.toolbar.actions,
          {
            key: 'invite',
            icon: 'user-plus',
            title: 'Invite User',
            showTitle: false,
            variant: 'default' as const,
            onClick: () => setInviteOpen(true),
          },
        ],
      },
    }),
    []
  );
  return (
    <div className={cn('flex flex-col h-full min-h-0', colors.background)}>
      <div className="flex-1 min-h-0 overflow-hidden">
        <GenericListPage<User>
          useData={useUsers}
          config={config}
        />
      </div>
      <InviteUserModal
        open={inviteOpen}
        onClose={() => setInviteOpen(false)}
        onSuccess={() => mutate?.()}
      />
    </div>
  );
};

export default List;

